import React, { FC } from 'react';
import { useTranslation } from '../../../utils/useTranslation';
import { SmartDrawer } from '../../feedback/SmartDrawer';
import { Box } from '../../layout/Box';
import { Flex } from '../../layout/Flex';
import { Typography } from '../../typography/Typography';
import { CollectionChooseNameForm } from '../CollectionChooseNameForm/CollectionChooseNameForm';
import { ActionButton } from '../styles';
import { PromoteShowInFeedDrawerProps, Step } from './types';

export const PromoteShowInFeedDrawer: FC<PromoteShowInFeedDrawerProps> = ({
    step,
    onClose,
    values,
    handlers,
}) => {
    const t = useTranslation();

    const mainContent = () => {
        if (step === Step.CONFIRM) {
            return (
                <Flex width="100%">
                    <Typography variant="body" pb={2}>
                        {t(
                            'Хотите поделиться своей коллекцией в ленте рекомендаций для других пользователей?',
                        )}
                    </Typography>
                    <Typography variant="body" pb={2}>
                        {t('Для этого нужно придумать ей название с помощью нейросети')}
                    </Typography>
                    <Flex pt={2} spacing={1} direction={{ xs: 'column', sm: 'row' }} width="100%">
                        <ActionButton color="secondary" onClick={onClose}>
                            {t('Позже')}
                        </ActionButton>
                        <ActionButton onClick={handlers.onChooseNameClick}>
                            {t('Придумать название')}
                        </ActionButton>
                    </Flex>
                </Flex>
            );
        }

        return (
            <Flex
                width="100%"
                minHeight={values.suggestsLoading ? '300px' : undefined}
                direction="column"
            >
                <Box m="auto">
                    <CollectionChooseNameForm values={values} handlers={handlers} hideTitle />
                </Box>
                <Box width="100%" pt={2} mt="auto">
                    <ActionButton
                        disabled={values.suggestsLoading || !values.currentSuggest}
                        onClick={handlers.onSubmit}
                    >
                        {t('Сохранить')}
                    </ActionButton>
                </Box>
            </Flex>
        );
    };

    const titleContent = () => (
        <Typography variant="title3" weight="bold">
            {t(step === Step.CONFIRM ? 'У вас отличный вкус!' : 'Выберите название коллекции')}
        </Typography>
    );

    return (
        <SmartDrawer
            hideTrigger
            titleContent={titleContent}
            mainContent={mainContent}
            onClose={onClose}
            defaultCloseButtonEnabled={step === Step.CHOOSE_NAME}
            forceCloseButton={step === Step.CHOOSE_NAME}
        ></SmartDrawer>
    );
};
